// Подпись под тумблером прогнозного хода судна.
//
// Молчащий тумблер неотличим от сломанного: линии нет — говорим почему, линия
// мягкая — говорим, отчего ей веры меньше. Слов здесь нет, только ключи: их
// вычитывает владелец в каталоге `i18n/ru.json` и `en.json`.
import { t } from '../i18n'

/** Все причины и оговорки, какие умеет вернуть `forecastRun`. Список нужен
 *  проверке полноты каталога: непереведённый ключ уедет в кабинет как есть. */
export const FORECAST_HINT_KEYS = [
  'noCourse',
  'notMoving',
  'moored',
  'staleFix',
  'manoeuvring',
  'unknownMode',
] as const

export function forecastHint(state: {
  reasonKey: string | null
  noticeKey: string | null
}): string {
  const key = state.reasonKey ?? state.noticeKey
  if (!key) return ''
  return t(`models.vesselForecast.${key}`)
}
